module.exports = "/assets/1051b6e63197471a80565f3cdc0a21bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/EY.png
// module id = 1353
// module chunks = 0